/* eslint-disable unused-imports/no-unused-imports */
import { Button, Card, CardContent, Grid, IconButton, Typography } from '@mui/material';
import { CheckboxForm, DatePicker, PhoneField, SelectInput, TextForm } from '../../../../components';
import useBooking from './use-Booking';
import CancelIcon from '@mui/icons-material/Cancel';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BookingForm = () => {
  const location = useLocation();
  const {
    control,
    countryItems,
    contentFields,
    contentAppend,
    contentRemove,
    chargesFields,
    chargesAppend,
    chargesRemove,
    onSubmit,
    documentId,
    navigate,
  } = useBooking();

  const { t, i18n } = useTranslation('common');

  return (
    <Grid container columnSpacing={5} rowSpacing={5}>
      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.quotation', { ns: 'placeholder' })}
          name='quotation'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          name='referenceCode'
          label={t('airGuide.invoiceQuoa', { ns: 'placeholder' })}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <DatePicker control={control} label={t('pdfs.expeditionDate', { ns: 'placeholder' })} name={'expeditionDate'} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Card variant={'outlined'}>
          <CardContent>
            <Grid container columnSpacing={5} rowSpacing={5}>
              <Grid item xs={12}>
                <Typography variant='subtitle1'>{t('pdfs.consignatario', { ns: 'placeholder' })}</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.name')}
                  name={'by.name'}
                  // disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.direction', { ns: 'placeholder' })}
                  name={'by.direction'}
                  // disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.email')}
                  name={'by.email'}
                  // disabled
                />
              </Grid>
              <Grid item xs={12}>
                <PhoneField control={control} label={t('general.phone')} name={'by.phone'} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Card variant={'outlined'}>
          <CardContent>
            <Grid container columnSpacing={5} rowSpacing={5}>
              <Grid item xs={12}>
                <Typography variant='subtitle1'>{t('airGuide.shipper', { ns: 'placeholder' })}</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.name', { ns: 'placeholder' })}
                  name={'shipper.name'}
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.direction', { ns: 'placeholder' })}
                  name={'shipper.direction'}
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.email')}
                  name={'shipper.email'}
                />
              </Grid>
              <Grid item xs={12}>
                <PhoneField control={control} label={t('general.phone')} name={'shipper.phone'} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('BL.notify', { ns: 'placeholder' })}
          name='notify'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.embarcador', { ns: 'placeholder' })}
          name='forwarder'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.contact', { ns: 'placeholder' })}
          name='contact'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.agent', { ns: 'placeholder' })}
          name='agent'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <PhoneField control={control} label={t('general.phone')} name='phone' />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.shipline', { ns: 'placeholder' })}
          name='shipline'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.reference', { ns: 'placeholder' })}
          name='reference'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.billOfLading', { ns: 'placeholder' })}
          name='billOfLading'
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.voyage', { ns: 'placeholder' })}
          name='voyage'
        />
      </Grid>

      <Grid item xs={12}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.via', { ns: 'placeholder' })}
          name='via'
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <DatePicker control={control} label={t('pdfs.departure', { ns: 'placeholder' })} name={'departure'} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <DatePicker control={control} label={t('pdfs.arrival', { ns: 'placeholder' })} name={'arrival'} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SelectInput
          disabled
          control={control}
          name='origin'
          label={t('pdfs.countryOrigin', { ns: 'placeholder' })}
          items={countryItems}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SelectInput
          disabled
          control={control}
          name='destination'
          label={t('pdfs.countryDestiny', { ns: 'placeholder' })}
          items={countryItems}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.employee', { ns: 'placeholder' })}
          name='employee'
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.comments', { ns: 'placeholder' })}
          name='comments'
        />
      </Grid>

      <Grid item xs={12}>
        <Card variant={'outlined'}>
          <CardContent>
            <CheckboxForm control={control} name='hazardous' label={t('pdfs.hazardous', { ns: 'placeholder' })} />
          </CardContent>
        </Card>
      </Grid>

      {/* CONTENIDO */}
      <Grid item xs={12}>
        <Grid container columnSpacing={5} rowSpacing={5}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Typography variant='subtitle1'> {t('general.content')} </Typography>
          </Grid>

          {contentFields.map((field, index) => (
            <Grid key={field.id} item>
              <Card variant='outlined' sx={{ p: 5, position: 'relative' }}>
                <Grid container columnSpacing={5} rowSpacing={5}>
                  <Grid item xs={12} sm={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.type', { ns: 'placeholder' })}
                      name={`content.${index}.type`}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.quantity', { ns: 'placeholder' })}
                      name={`content.${index}.quantity`}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.grossWeight', { ns: 'placeholder' })}
                      name={`content.${index}.grossWeight`}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.volume', { ns: 'placeholder' })}
                      name={`content.${index}.volume`}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.description', { ns: 'placeholder' })}
                      name={`content.${index}.description`}
                    />
                  </Grid>

                  {index !== 0 && (
                    <Grid item xs={12}>
                      <IconButton
                        onClick={() => {
                          contentRemove(index);
                        }}
                        color='error'
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          fontSize: '16px',
                          paddingLeft: '32px',
                          paddingTop: '4px',
                        }}
                      >
                        <CancelIcon />
                        {t('general.deleteContent')}
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          ))}

          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Button
              type='button'
              disabled={contentFields.length >= 10}
              sx={{ color: '#00ef14' }}
              onClick={() => {
                contentAppend({
                  type: '',
                  quantity: null,
                  description: '',
                  grossWeight: null,
                  volume: null,
                });
              }}
            >
              <i className='fa-solid fa-circle-plus text-xl text-green-500 mr-2' />
              <p>{t('add.content')}</p>
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {/* CARGAS */}
      <Grid item xs={12}>
        <Grid container columnSpacing={5} rowSpacing={5}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Typography variant='subtitle1'>{t('pdfs.charges.charges', { ns: 'placeholder' })}</Typography>
          </Grid>
          {chargesFields.map((field, index) => {
            return (
              <Grid key={field.id} item xs={12}>
                <Card variant='outlined' sx={{ p: 5, position: 'relative' }}>
                  <Grid container columnSpacing={5} rowSpacing={5}>
                    <Grid item xs={12} sm={4}>
                      <TextForm
                        translationFile='validations'
                        control={control}
                        label={t('pdfs.description', { ns: 'placeholder' })}
                        name={`charges.${index}.description`}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextForm
                        translationFile='validations'
                        control={control}
                        label={t('pdfs.charges.prepaid', { ns: 'placeholder' })}
                        name={`charges.${index}.prepaid`}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <TextForm
                        translationFile='validations'
                        control={control}
                        label={t('pdfs.charges.collect', { ns: 'placeholder' })}
                        name={`charges.${index}.collect`}
                      />
                    </Grid>
                    {index !== 0 && (
                      <Grid item xs={12}>
                        <IconButton
                          onClick={() => {
                            chargesRemove(index);
                          }}
                          color='error'
                          sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            fontSize: '16px',
                            paddingLeft: '32px',
                            paddingTop: '4px',
                          }}
                        >
                          <CancelIcon />
                          {t('general.deleteCharge')}
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                </Card>
              </Grid>
            );
          })}
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Button
              type='button'
              sx={{ color: '#00ef14' }}
              onClick={() => {
                chargesAppend({
                  description: '',
                  collect: null,
                  prepaid: null,
                });
              }}
              disabled={chargesFields.length > 4}
            >
              <i className='fa-solid fa-circle-plus text-xl text-green-500 mr-2' />
              <p>{t('airGuide.addCharges', { ns: 'placeholder' })}</p>
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Button variant='contained' onClick={onSubmit}>
          {documentId === null
            ? i18n.language === 'es'
              ? 'Guardar'
              : 'Save'
            : t('budgetGuide.saveDocumentButtonTittle')}
        </Button>

        {documentId !== null && (
          <Button
            variant='contained'
            onClick={() => navigate(documentId, location.pathname + '&value=3')}
            color='secondary'
          >
            {t('budgetGuide.viewDocumentButtonTittle')}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default BookingForm;
